import React from 'react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import BaseMainLayout from './baseLayout';
const WebMainLayout = ({ children }) => (React.createElement(ConfigProvider, { locale: zhCN },
    React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
        React.createElement("div", { style: { position: 'relative' } },
            React.createElement(BaseMainLayout, null, children)))));
export default WebMainLayout;
